import { slugify } from '@confluent/shared/lib/slug';
import type { MarketplaceListing } from '../../services/api/marketplace.api.js';

/**
 * Turns a listing title into a URL/slug-safe default for the fork form.
 *
 * `maxLength: 100` matches `entities.slug`. It goes through the shared helper because the server
 * derives slugs with the same one — a private copy here would disagree about accents (`Café` becomes
 * `cafe`, not `caf`) and about a truncation that lands on the separator, and the client would offer
 * a default the server then rejects.
 */
export function slugifyListingTitle(title: string): string {
  return slugify(title, { maxLength: 100 });
}

/** §3/§7: forking is allowed only on a public listing — a private listing is runnable only. */
export function canForkListing(listing: Pick<MarketplaceListing, 'contentAccess'>): boolean {
  return listing.contentAccess === 'public';
}
